import { render, staticRenderFns } from "./ErrorVerifyIdentity.vue?vue&type=template&id=e21805ba&scoped=true&"
import script from "./ErrorVerifyIdentity.vue?vue&type=script&lang=ts&"
export * from "./ErrorVerifyIdentity.vue?vue&type=script&lang=ts&"
import style0 from "./ErrorVerifyIdentity.vue?vue&type=style&index=0&id=e21805ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e21805ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VImg,VRow})
